import { Catalog } from '@philips-internal/oswald-ui-core';
class Renderer {
    constructor() {
        this.fromMetadata = (root) => {
            return this.traverseMetadata(root);
        };
        this.traverseMetadata = (node) => {
            const component = this.getComponentByType(node);
            const props = this.getComponentProps(node);
            return this.createElement(component, props, node.children);
        };
    }
    createElement(component, props, children) {
        throw new Error(`Invalid renderer: ${component}, ${props}, ${children}.`);
    }
    getComponentByType({ type }) {
        try {
            return Catalog.get(type).getComponent();
        }
        catch (e) {
            throw new Error(`[Renderer]: Problem to get component '${type}', error: '${e}'`);
        }
    }
    getComponentMetadataByType(node) {
        try {
            return Catalog.get(node.type);
        }
        catch (e) {
            throw new Error(`[Renderer]: Problem to get component component '${node.type}', error: '${e}'`);
        }
    }
    getComponentProps({ props }) {
        return { key: props.uuid, ...props };
    }
}
export { Renderer, };
//# sourceMappingURL=renderer.js.map